/**
 * 嵌入导航协议 v1 基座侧解析。
 * 契约：cxin-ai-web docs/contracts/embed-navigation-protocol.md（消息构造在 AI 侧 lib/embed-bridge.ts）。
 * 接收方丢弃自己不认识的 v / page / module：旧基座对新消息天然前向兼容。
 */

export const CARGO_AI_NAVIGATE_TYPE = 'cargo-ai/navigate'
export const CARGO_AI_PROTOCOL_VERSION = 1

// v1 唯一页型与模块；扩模块时在此登记（映射表见 cargoAiRouter.js）
const KNOWN_PAGES = ['job_workspace']
const KNOWN_MODULES = ['SE']
const KNOWN_ACTIONS = ['look', 'copy']

function isNonEmptyString(value) {
  return typeof value === 'string' && value.length > 0
}

/**
 * 校验并归一化 cargo-ai/navigate 消息。
 * 非 cargo-ai/navigate 的消息静默返回 null（页面里还有别的 postMessage 流量）；
 * 是本协议但内容不认识的，console.warn 后返回 null。
 * @param {*} data - postMessage 的 event.data
 * @returns {Object|null} { page, module, action, jobNo, jobUuid }
 */
export function parseNavigateMessage(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return null
  }
  if (data.type !== CARGO_AI_NAVIGATE_TYPE) {
    return null
  }
  if (data.v !== CARGO_AI_PROTOCOL_VERSION) {
    console.warn('[CargoAi] 忽略不认识的协议版本:', data.v)
    return null
  }
  if (!KNOWN_PAGES.includes(data.page)) {
    console.warn('[CargoAi] 忽略不认识的页型:', data.page)
    return null
  }
  if (!KNOWN_MODULES.includes(data.module)) {
    console.warn('[CargoAi] 忽略不认识的业务模块:', data.module)
    return null
  }
  if (!KNOWN_ACTIONS.includes(data.action)) {
    console.warn('[CargoAi] 忽略不认识的动作:', data.action)
    return null
  }
  const jobNo = isNonEmptyString(data.job_no) ? data.job_no : ''
  const jobUuid = isNonEmptyString(data.job_uuid) ? data.job_uuid : ''
  if (!jobNo && !jobUuid) {
    console.warn('[CargoAi] 导航消息缺少单号/uuid，忽略')
    return null
  }
  return {
    page: data.page,
    module: data.module,
    action: data.action,
    jobNo,
    jobUuid
  }
}
